import {AfterViewInit, Component, EventEmitter, Inject, isDevMode, OnDestroy, OnInit, Output} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import { ContractForm} from '../../models/contract';
import {ActivatedRoute, Router} from '@angular/router';
import {AddContractAction} from '../../actions/contract-add';
import {select, Store} from '@ngrx/store';
import * as fromContracts from '../../reducers';
import {LoadProductsCompleteListAction, LoadProductsCompleteListClearAction} from '../../../shared/actions/product-complete-list';
import * as fromRoot from '../../../shared/reducers';
import {LoadProductsAction} from '../../../shared/actions/product';
import {Role} from '../../../shared';
import * as _ from 'lodash';
import {CompanyService} from '../../../company/services/company.service';
import {FormGroup} from '@angular/forms';
import {FindInvalidControlsService} from '../../../shared/services/find-invalid-controls.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DuplicateService} from '../../../shared/services/duplicate.service';
import {UpdateDynamicFormService} from '../../../shared/services/update-dynamic-form.service';
import {Product} from '../../../shared/models/product';
import * as moment from 'moment';
import {FooterDetails} from '../../../order/models/footer-extra-info';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as fromContract from '../../reducers';
import {CurrencyObject} from '../../models/currency';

@Component({
  selector: 'storever-contract-edit',
  templateUrl: './contract-edit.component.html',
  styleUrls: ['./contract-edit.component.scss'],
})
export class ContractEditComponent implements OnInit, OnDestroy , AfterViewInit {

  dataConfig: DataConfig;
  content: Observable<ContractForm>;
  @Output() saveForm = new EventEmitter<Object>();
  contract: ContractForm;
  companyName: string;
  contractNamePrefix: string;
  roles$: Observable<Role[]>;
  product$: Observable<Product[]>;
  private sub$: Subscription;
  private subscriptions = [];
  error: FooterDetails[];
  currencyList: CurrencyObject[];
  currencyValue: string;
  constructor( private activatedRoute: ActivatedRoute,
               private storeRoot: Store<fromRoot.AppState>,
               private companyService: CompanyService,
               private router: Router,
               @Inject(L10N_LOCALE) public locale: L10nLocale,
               private duplicate: DuplicateService,
               private updateDynamicFormService: UpdateDynamicFormService,
               private findInvalidControlsService: FindInvalidControlsService,
               private storeContract: Store<fromContracts.AppState>) {
    this.roles$ = this.storeRoot.pipe(select(fromRoot.selectors.getMyRoles));
    this.product$ = this.storeRoot.pipe(select(fromRoot.selectors.getProducts));
    this.getCompanyName();
  }

  get isEdit(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:contractId'
  }

  ngOnInit(): void {
    this.checkValidityDate();
    this.isInRole();
    if (this.isEdit) {
      this.dataConfig.form.disable();
    } else {
      if (this.companyName) {
        this.dataConfig.groupConfigs.groupConfigs[1].config[0].options.inputExtraLabels = 'Contract ' + ' ' + this.companyName;
      } else {
        this.dataConfig.groupConfigs.groupConfigs[1].config[0].options.inputExtraLabels = 'Contract ' ;
      }
      this.dataConfig.form.get(['contract' , 'split' , 'split' , 'id']).patchValue(6);
    }

    this.dataConfig.form.get(['contract', 'productID']).valueChanges.subscribe(data => {
      if (data) {
        if (!this.isEdit) {
          this.product$.subscribe(product => {
            if (product) {
              // tslint:disable-next-line:typedef
              const currentProduct = _.filter(product, function(o) { return o.id === data.productID.id; })
              this.contractNamePrefix = 'Contract ' + currentProduct[0].name + ' ' + (this.companyName ? this.companyName : '');
              this.dataConfig.groupConfigs.groupConfigs[1].config[0].options.inputExtraLabels = this.contractNamePrefix;
              this.dataConfig.form.get(['contract' , 'prefix' ]).patchValue(this.contractNamePrefix);
              const displayName = this.dataConfig.form.get(['contract', 'displayName' , 'displayName']).value;
              this.nameExist(displayName);
            }
          })
        }
      }
      if (data && (data.productID.id  === 6 ||  data.productID.id  === 7) ) {
        this.dataConfig.groupConfigs.groupConfigs[6].config[0].options.hideOption = null;
      } else {
        this.dataConfig.groupConfigs.groupConfigs[6].config[0].options.hideOption = 2;
        if (this.dataConfig.form.get(['contract' , 'triggerStart' , 'triggerStart' , 'id']).value === 2) {
          this.dataConfig.form.get(['contract' , 'triggerStart' , 'triggerStart' , 'id']).patchValue(null);
        }
      }
    })

    this.content = this.dataConfig.content;
    this.content.subscribe(sub => {
      this.contract = sub;
      this.dataConfig.form.get(['contract']).patchValue(sub);
      this.dataConfig.groupConfigs.groupConfigs[1].config[0].options.inputExtraLabels = sub.prefix;
      this.dataConfig.form.get(['contract' , 'prefix' ]).patchValue(sub.prefix);
    })
    this.sub$ = this.dataConfig.form.get(['contract', 'displayName', 'displayName']).valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(name => {
      this.nameExist(name);
    })
    this.subscriptions.push(this.sub$);

    this.sub$ = this.dataConfig.form.get(['contract', 'recurrence' , 'allowShiftMonth']).valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value) {
        this.updateDynamicFormService.updateElement('BillingShiftMonth', true, 'toggle');
      } else {
        this.updateDynamicFormService.updateElement('BillingShiftMonth', false, 'toggle');
      }
    })
    this.subscriptions.push(this.sub$);

    this.sub$ =  this.storeRoot.pipe(select(fromContract.selectors.getCurrencies)).subscribe((data) => {
      if (data) {
        this.currencyList = data;
        this.getCurrencyInfo();
      }
    })
    this.subscriptions.push(this.sub$);
    this.dataConfig.form.markAsPristine();
  }

  ngAfterViewInit(): void {
    if (this.isEdit) {
   this.storeRoot.dispatch(new LoadProductsCompleteListAction());
    }
  }

  nameExist(name: string): void {
  const nameDup = (this.contractNamePrefix ? this.contractNamePrefix : this.dataConfig.form.get(['contract', 'prefix']).value) + ' ' + name
  this.sub$ =  this.duplicate.duplicate(['contractName'] ,  nameDup).pipe(
    distinctUntilChanged((x, y) => _.isEqual(x, y)  ),
  ).subscribe((res: boolean) => {
    if (res === true) {
      this.dataConfig.form.get(['contract', 'displayName']).setErrors({  });
      this.updateDynamicFormService.updateElement('displayName', true, 'duplicate');
    } else {
      this.dataConfig.form.get(['contract', 'displayName']).setErrors(null);
      this.updateDynamicFormService.updateElement('displayName', false, 'duplicate');
    }
  })
  this.subscriptions.push(this.sub$);
  this.dataConfig.form.markAsPristine();
  }

  isInRole(): void {
    this.roles$.subscribe(roles => {
        let index;
        index =   _.findIndex(roles, ['code', 'BO_BILLING_CHANGE_CURRENCY'])  ;
        if (index !== -1) {
          this.dataConfig.groupConfigs.groupConfigs[11].config[0].presentation = 'edit';

        } else {
          if (!this.isEdit) {
            this.dataConfig.form.get(['contract' , 'currency' , 'currency' , 'id']).patchValue(4);
            this.getCurrencyInfo();
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
    this.dataConfig.form.reset();
    this.updateDynamicFormService.updateElement('displayName', false, 'duplicate');
    this.storeRoot.dispatch(new LoadProductsCompleteListClearAction());
    this.storeRoot.dispatch(new LoadProductsAction());
  }
  getCompanyName(): void {
    if (!this.companyName) {
      this.sub$ = this.companyService.load(this.router.url.split('?')[0].split('/')[1]).subscribe(c => {
        if (c && c.data && !this.isEdit) {
          this.companyName = c.data.displayName;
          this.contractNamePrefix = 'Contract' + ' ' + this.companyName;
          this.dataConfig.groupConfigs.groupConfigs[1].config[0].options.inputExtraLabels = this.contractNamePrefix;
        }
      });
      this.subscriptions.push(this.sub$);
    }
  }
  /**
   * - Value from FormGroup
   * - Update/patch part of the object
   * @param apiNames
   */
  save(apiNames: string[]): void {}

  undo(formPath: string[]): void {}



  edition(): void {
    this.dataConfig.form.get(['contract']).enable({ emitEvent: true });
    this.dataConfig.form.get(['contract', 'productID']).disable();
  }
  undoBlock(): void {
    this.dataConfig.form.get(['contract']).patchValue(this.contract);
    this.dataConfig.form.markAsPristine();
    this.dataConfig.form.disable({ emitEvent: false });
  }
  saveBlock(): void {
    if (this.dataConfig.form.get(['contract']).valid && this.dataConfig.form.get(['contract']).dirty) {
      this.dataConfig.form.get(['contract', 'productID']).enable();
      const resp = this.dataConfig.form.get(['contract']).value;
      if (!resp.invoicing.end) {
        resp.invoicing.end = '2099-12-31'
      }
      this.dataConfig.form.get(['contract']).patchValue(resp);
      this.dataConfig.form.markAsUntouched();
      this.dataConfig.form.markAsPristine();
      this.dataConfig.form.disable({ emitEvent: false });
      this.storeContract.dispatch(new AddContractAction(resp));
      this.storeRoot.dispatch(new LoadProductsCompleteListClearAction());
      this.storeRoot.dispatch(new LoadProductsCompleteListAction());
    }
    this.dataConfig.form.markAsPristine();
  }
  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }
  checkValidityDate(): void {
    this.sub$ = this.dataConfig.form.get(['contract']).valueChanges.subscribe((data) => {
      if (data.invoicing.start !== 'Invalid date' && data.invoicing.end !== 'Invalid date') {
        this.error = null;
        this.error = [];
        this.dataConfig.form.get(['contract']).setErrors(null);
        this.updateErrorDate(data.invoicing.start, data.invoicing.end)
      }
    })
    this.subscriptions.push(this.sub$);
  }

  updateErrorDate(start: string , end: string): void {
    if (start && end && !moment(start).isBefore(end)) {
      this.error[0] = {
        icon: 'fa fa-ban',
        color: 'red',
        message: 'End date must be bigger than the start date',
        extraData: ''
      }
      this.dataConfig.form.get(['contract']).setErrors({ required: true });

    }
  }
  getCurrencyInfo(): string {
    const currentId = this.dataConfig.form.get(['contract' , 'currency' , 'currency' , 'id']).value;
    if (currentId === 4) {
      this.currencyValue = null;
    } else {
          // tslint:disable-next-line:typedef
          const currentCurrency = _.filter(this.currencyList, function(o) { return o.id === currentId; })
          if (currentCurrency.length > 0) {
          this.currencyValue = '1 Euro = ' + currentCurrency[0].lastRate + ' ' + currentCurrency[0].name;
        }

        }
    return this.currencyValue;
  }
}
